export const DEFAULT_ERROR_TEXT_HEIGHT = 16;
export const UNREAD_GLOB_NOTIFICATIONS_DELAY = 600000;
export const GLOB_NOTIFICATIONS_PER_PAGE = 15;
export const QS_ARRAY_DELIMITER = ';';

export const EMPTY = '—';
export const DEFAULT_PER_PAGE = 30;
